import type { MouseEvent } from "react";
import { Link } from "react-router";
import { styled } from "styled-components";

import { ChevronIcon } from "common/components";

const StyledSeeDetailButton = styled(Link)<{ $isSmall: boolean }>`
  transition: background-color 0.3s;
  padding: ${({ $isSmall }) => ($isSmall ? "2px" : "6px 8px")};
  border-radius: 5px;
  color: ${({ theme }) => theme.colors.topHeaderBarText};
  height: 20px;
  width: 20px;
  ${({ $isSmall }) =>
    $isSmall &&
    `
      flex: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    `};

  &:hover {
    background-color: ${({ theme }) => theme.colors.backgroundPrimary};
  }
`;

const StyledChevron = styled(ChevronIcon)<{ $isSmall: boolean }>`
  width: ${({ $isSmall }) => ($isSmall ? "14px" : "14px")};
  height: ${({ $isSmall }) => ($isSmall ? "14px" : "14px")};
`;

type KnowledgeDetailButtonProps = {
  className?: string;
  isSmall?: boolean;
  link: string;
  onClick?: (event: MouseEvent) => void;
  title?: string;
};

export const KnowledgeDetailButton = ({
  link,
  onClick,
  className,
  isSmall = true,
  title = "",
}: KnowledgeDetailButtonProps) =>
  !link && !onClick ? null : (
    <div>
      <StyledSeeDetailButton
        {...(!link || link.startsWith("/") ? {} : { as: "a", href: link, target: "_blank" })}
        $isSmall={isSmall}
        className={className}
        onClick={onClick}
        rel="noopener"
        title={`View details for ${title}`}
        to={link}
      >
        <StyledChevron $isSmall={isSmall} />
      </StyledSeeDetailButton>
    </div>
  );
